import React, { Component, PropTypes } from 'react';
import ReactSparkModal from '../helpers/CTModal';

class ReactSparkConfirmationDialog extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ReactSparkModal
                open={this.props.open}
                primaryButtonTitle="Yes"
                primaryButton={true}
                secondaryButton={true}
                primaryButtonClick={this.props.onPrimaryClick}
                secondaryButtonClick={this.props.onSecondaryClick}
                secondaryButtonTitle="No"
            >
                <div className="spark-message spark-message--lg spark-message--error spark-margin-bottom">
                    <i className="spark-message__icon spark-icon-trash spark-icon--fill" />
                    <div className="spark-message__content">
                        <h4 className="spark-message__heading">{this.props.headline}</h4>
                        <p>{this.props.message}</p>
                    </div>
                </div>
            </ReactSparkModal>
        );
    }
}

ReactSparkConfirmationDialog.propTypes = {
    open: PropTypes.bool,
    onPrimaryClick: PropTypes.func,
    onSecondaryClick: PropTypes.func,
    headline: PropTypes.string,
    message: PropTypes.string
};

export default ReactSparkConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/widgets/ReactSparkConfirmationDialog.js